import { Icon, IconSizeClasses, Select, Tooltip } from '@eppendorf/vnls-react-components';
import { UseFormReturn } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

import {
  notificationDelayOptions,
  defaultNotificationDelay,
} from '$features/notifications/add-or-edit-notification-rule-dialog/constants';
import { NotificationRuleSubmitForm } from '$features/notifications/types';

import './notification-delay.scss';

type NotificationDelayProps = { formControl: UseFormReturn<NotificationRuleSubmitForm> };

export function NotificationDelay({ formControl }: NotificationDelayProps) {
  const { t } = useTranslation();
  const { watch, setValue } = formControl;

  const notificationDelay = watch(
    'notificationSendDelaySeconds',
    defaultNotificationDelay,
  );

  const handleChange = (value: string) => {
    setValue('notificationSendDelaySeconds', Number(value), {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <div className="notification-delay__wrapper">
      <Tooltip
        trigger={
          <div className="notification-delay flex flex__ai--center flex__jc--center p-s bg-blue-800 font-color-white border-radius-m color-white">
            <div className="flex flex__ai--center flex__jc--center icon--s">
              <Icon name="delay" size={IconSizeClasses.Small} className="bg-white" />
            </div>
            <p className="p-left-s p-right-m">{t('escalationLayer.notificationDelay')}</p>
            <div style={{ width: 130 }} className="p-right-xs color-black">
              <Select
                value={notificationDelay.toString()}
                onChange={handleChange}
                options={notificationDelayOptions}
                ariaLabel="notification delay"
              />
            </div>
          </div>
        }
      >
        <Trans
          i18nKey="notificationDetail.tooltipDelay"
          components={{
            bold: <span className="font-weight-bold" />,
            regular: <span style={{ opacity: 0.8 }} />,
          }}
        />
      </Tooltip>

      <div className="notification-delay__tail--after" />
    </div>
  );
}
